import React from "react";
import { Navigate, useLocation } from "react-router";
import { useUser } from '../components/UserContext';
import { JSX } from "react/jsx-runtime";

export function RequirePermission({
    perm,
    children,
}: {
    perm: string;
    children: JSX.Element;
}) {
    const { isSysAdmin, user } = useUser();
    const location = useLocation();

    if (!user) return <Navigate to="/login" replace state={{ from: location }} />;

    const perms = user.system?.permissions ?? [];
    if (!perms.includes(perm)) return <Navigate to="/forbidden" replace />;

    return children;
}
